import * as swcHelpers from '@swc/helpers';
import { unwrapResponse } from '../../response.js';
import { acceptJson, postJson, authHeader } from '../../shared.js';

function changePassword(apiUrl, accessToken, customerId, request) {
    return _changePassword.apply(this, arguments);
}
function _changePassword() {
    _changePassword = swcHelpers.asyncToGenerator(function*(apiUrl, accessToken, customerId, request) {
        return unwrapResponse((yield fetch(`${apiUrl}/customers/account/password/${encodeURIComponent(customerId)}/change`, {
            method: 'POST',
            headers: swcHelpers.objectSpread({}, acceptJson, postJson, authHeader(accessToken)),
            body: JSON.stringify(request)
        })), {
            useResponseError: true,
            responseErrorMapper: (result)=>{
                return {
                    auth0ErrorCode: result === null || result === void 0 ? void 0 : result.customData.auth0ErrorCode
                };
            }
        });
    });
    return _changePassword.apply(this, arguments);
}

export { changePassword };
//# sourceMappingURL=change.js.map
